import React, { Component } from 'react'

export default class FeeCard extends Component {
    render() {
        return (
            <div>
                <h1>Fee Card</h1>
            </div>
        )
    }
}
